"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfigSettings = /** @class */ (function () {
    function ConfigSettings() {
        this._apiPath = '/consent';
        this._clientVersion = '1';
        this._clientId = 'rvuconsent';
        this._brand = 'money';
    }
    Object.defineProperty(ConfigSettings.prototype, "apiPath", {
        get: function () {
            return this._apiPath;
        },
        set: function (path) {
            this._apiPath = path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigSettings.prototype, "clientVersion", {
        get: function () {
            return this._clientVersion;
        },
        set: function (version) {
            this._clientVersion = version;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigSettings.prototype, "clientId", {
        get: function () {
            return this._clientId;
        },
        set: function (id) {
            this._clientId = id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigSettings.prototype, "brand", {
        get: function () {
            return this._brand;
        },
        set: function (brand) {
            this._brand = brand;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * setNewConfigValues
     */
    ConfigSettings.prototype.setNewConfigValues = function (params) {
        var path = params.path, _a = params.version, version = _a === void 0 ? null : _a, _b = params.id, id = _b === void 0 ? null : _b, _c = params.brand, brand = _c === void 0 ? null : _c;
        if (path)
            this._apiPath = path;
        if (version)
            this._clientVersion = version;
        if (id)
            this._clientId = id;
        if (brand)
            this._brand = brand;
        return this.returnConfigObject();
    };
    /**
     * returnConfigObject
     */
    ConfigSettings.prototype.returnConfigObject = function () {
        return {
            apiPath: this._apiPath,
            clientVersion: this._clientVersion,
            clientId: this._clientId,
            brand: this._brand,
        };
    };
    return ConfigSettings;
}());
exports.default = new ConfigSettings();
